import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  BackendIcon,
  CPAppIcon,
} from "../../../../app-constants";

const StackItem = [
  {
    icon: IphoneIcon,
    title: "Mobile Frontend",
    description:
      "Native (Java/Kotlin), Xamarin Native C,  Xamarin Forms for Android, Cordova/PhoneGap, Ionic, React Native, Flutter",
  },
  {
    icon: AndroidIcon,
    title: "Operating System",
    description: "Android OS",
  },
  {
    icon: CPAppIcon,
    title: "SDKs/Tools/Framework",
    description:
      "Android Studio, Google Fit SDK, Google Assistant SDK, OpenGL, ARCore, Android Auto",
  },
  {
    icon: BackendIcon,
    title: " Platforms",
    description:
      "Amazon Web, Services (AWS), Microsoft Azure, Google Cloud, Platform (GCP), Firebase, AppCenter for CI/CD, Kubernetes",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>
                Technologies TekRevol Uses for Android App Development in UK
              </h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              At TekRevol, we leverage cutting-edge Android app development
              tools and the latest technologies to ensure your project is at the
              forefront of innovation. Our commitment to using the best Android
              app development platforms is reflected in the quality and
              efficiency of our work. We stay ahead of the latest Android app
              development technology, incorporating advancements that enhance
              the performance and user experience of your applications. Here are
              the Android app development technologies that TekRevol uses:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
